import React from 'react';

import { withAuthLayout } from '@/layouts/Auth';

import { Action } from '@bypasslane/clover--web-lib-sprout-action';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { equals, last, pipe, split } from 'ramda';

const Redirect = ({ redirectUrl = null }) => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  const getTLD = pipe(split('.'), last);

  const isSameTLD = (url) => {
    try {
      const redirectTLD = getTLD(new URL(url).hostname);
      const currentTLD = getTLD(globalThis.location.hostname);
      return equals(redirectTLD, currentTLD);
    } catch {
      return false;
    }
  };

  const tldMismatch = redirectUrl && !isSameTLD(redirectUrl);

  if (!isDevelopment && redirectUrl && !tldMismatch) {
    globalThis.location.href = redirectUrl;
    return null;
  }

  return (
    <div className="p-4 flex flex-col items-center space-between">
      <h2 className="text-xl font-bold mb-6 flex-1">
        {tldMismatch ? 'Domain Mismatch Error' : 'Redirecting...'}
      </h2>
      {tldMismatch && (
        <div className="text-red-500 mb-6 flex-1">
          <p>TLD mismatch detected. Cannot redirect to the specified URL.</p>
          <p>
            Cookies cannot be shared across different top-level domains (TLDs), which may cause
            authentication or session issues.
          </p>
        </div>
      )}
      <code
        className={classNames(
          'text-sm sm:text-base',
          'inline-flex text-left',
          'items-center space-x-4',
          'bg-gray-200 text-white',
          'rounded-lg p-4 pl-6'
        )}
      >
        <span className="flex gap-4">
          <span className="shrink-0 text-gray-500">{redirectUrl}</span>
        </span>
      </code>
      {!tldMismatch && (
        <Action onClick={() => (globalThis.location.href = redirectUrl)} className="mt-6 flex-1">
          Continue to URL
        </Action>
      )}
    </div>
  );
};

export default withAuthLayout(Redirect, {
  enableProfiler: true,
  enableErrorBoundary: true
});
Redirect.propTypes = {
  redirectUrl: PropTypes.string
};
Redirect.displayName = 'Redirect';
